export enum EducationLevel {
  Elementary = 'Elementary school',
  Middle = 'Middle school',
  High = 'High school'
}

export enum ChildDiscipline {
  Math = 'Math',
  Reading = 'Reading',
  Both = 'Both'
}
